package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.animation.animateContentSize
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.LinearProgressIndicator
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.feature.presentation.inspection.answer.InspectionAnswerState

@Composable
fun InspectionAnswerProgress(
    state: InspectionAnswerState,
    modifier: Modifier = Modifier,
    dimension: AppDimension = LocalAppTheme.current.dimension
) {
    val totalCount by remember(state.page) {
        derivedStateOf { state.totalCount }
    }
    val answeredCount by remember(state.page) {
        derivedStateOf { state.answeredCount }
    }
    val targetProgress by remember(totalCount, answeredCount) {
        derivedStateOf { if (totalCount == 0) 0f else answeredCount.toFloat() / totalCount }
    }

    val animatedProgress by animateFloatAsState(
        targetValue = targetProgress,
        animationSpec = tween(durationMillis = 450)
    )

    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(dimension.spacing.space2),
        verticalAlignment = Alignment.CenterVertically
    ) {
        LinearProgressIndicator(
            progress = { animatedProgress },
            modifier = modifier
                .weight(1f)
                .animateContentSize(),
            gapSize = dimension.spacing.space0,
            trackColor = LocalAppTheme.current.color.icon.disabled,
            drawStopIndicator = {
                // no-op
            }
        )
    }
}
